import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-mandatory-data-missing',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './mandatory-data-missing.component.html',
  styleUrl: './mandatory-data-missing.component.css'
})
export class MandatoryDataMissingComponent {
  @Output() onClick = new EventEmitter<void>();

  handleClick() {
    this.onClick.emit();
  }
}
